import React from "react";
import AdminQuizList from "./AdminQuizList";
import UserQuizList from "./UserQuiz/UserQuizList";
import { connect } from "react-redux";

const Quiz = ({ userRole }) => {
  return userRole === "SuperAdmin" ? <AdminQuizList /> : <UserQuizList />
}
const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "User",
});

export default connect(mapStateToProps)(Quiz);

